import config from "../../config"
import RequestService from "../RequestService"

const createMaterial = (params, successCallback, failureCallback) => {
  RequestService.post(`${config.backendUrl}/materials`, { material: params }, successCallback, failureCallback)
}

export default createMaterial;